import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import VM from 'scratch-vm';
import { connect } from 'react-redux';

import analytics from '../lib/analytics';
import ControlsComponent from '../components/controls/controls.jsx';

class Controls extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleGreenFlagClick',
            'handleStopAllClick',
            'handletoCode',
            'handleclosePanel'
        ]);
    }
    handleGreenFlagClick (e) {
        e.preventDefault();
        if (e.shiftKey) {
            this.props.vm.setTurboMode(!this.props.turbo);
        } else {
            if (!this.props.isStarted) {
                this.props.vm.start();
            }
            this.props.vm.greenFlag();
            analytics.event({
                category: 'general',
                action: 'Green Flag'
            });
        }
    }
    handleStopAllClick (e) {
        e.preventDefault();
        this.props.vm.stopAll();
        analytics.event({
            category: 'general',
            action: 'Stop Button'
        });
    }
    
    handletoCode () {
        this.props.toCode();
    }
    handleclosePanel () {
        this.props.closePanel();
    }

    handleChangeWidth (e) {
        e.preventDefault();
        var documents = document.getElementsByClassName('gui_flex-wrapper_2AgdD')[0];
        var code = document.getElementsByClassName('stop-all_draggabe-line_2YKF2')[0].parentNode;
        var width = code.clientWidth;
        var current = e.clientX;
        var titledocuemnt = code.childNodes[0].children[0];
        var contentdocument = code.childNodes[2];

        documents.onmousemove = function (e) {

            var num = current - e.clientX;
            var changewidth = width + num;
            code.style.width = changewidth + 'px';
            titledocuemnt.style.width = changewidth + 'px';
            contentdocument.style.width = changewidth + 'px';
        };
        documents.onmouseup = function () {
            documents.onmousemove = null;
            documents.onmouseup = null;
        };
    }
    
    render () {
        const {
            vm, // eslint-disable-line no-unused-vars
            isStarted, // eslint-disable-line no-unused-vars
            projectRunning,
            turbo,
            ...props
        } = this.props;
        return (
            <ControlsComponent
                {...props}
                active={projectRunning}
                closePanel={this.handleclosePanel}
                toCode={this.handletoCode}
                turbo={turbo}
                onGreenFlagClick={this.handleGreenFlagClick}
                onStopAllClick={this.handleStopAllClick}
                onChangeWidth={this.handleChangeWidth}
            />
        );
    }
}

Controls.propTypes = {
    closePanel: PropTypes.func,
    isStarted: PropTypes.bool.isRequired,
    projectRunning: PropTypes.bool.isRequired,
    toCode: PropTypes.func,
    turbo: PropTypes.bool.isRequired,
    vm: PropTypes.instanceOf(VM)
};

const mapStateToProps = state => ({
    isStarted: state.scratchGui.vmStatus.running,
    projectRunning: state.scratchGui.vmStatus.running,
    turbo: state.scratchGui.vmStatus.turbo,
    closePanel: state.scratchGui.vm.closePanel.bind(state.scratchGui.vm),
    toCode: state.scratchGui.vm.toCode.bind(state.scratchGui.vm)

});
// no-op function to prevent dispatch prop being passed to component
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Controls);
